import { NodeModel } from '@xanadu/model';

export class MenuData {
    position?: {x: number, y: number};
    viewModel?: NodeModel;
}
